// import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const ProfileGet = async(persona) => {
    try {
        if (persona === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: Persona')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/profiles/${persona}`,
        })
    } catch (e) {
        console.error(e)
    }
}